// Prosjekt- og timeregistreringstekster for en.
window.PlummeI18n.register('en', {
  'pj.tab.time': 'Timesheet',
  'pj.tab.overview': 'Overview',
  'pj.tab.settings': 'Settings',
  'pj.day.mon': 'Mon',
  'pj.day.tue': 'Tue',
  'pj.day.wed': 'Wed',
  'pj.day.thu': 'Thu',
  'pj.day.fri': 'Fri',
  'pj.day.sat': 'Sat',
  'pj.day.sun': 'Sun',
  'pj.person.fallback': 'you',
  'pj.time.title': 'Timesheet for {name}',
  'pj.week.label': 'Week {week}',
  'pj.week.word': 'Week',
  'pj.week.pick': 'Choose week',
  'pj.week.current': 'This week',
  'pj.week.back': 'Three weeks back',
  'pj.week.forward': 'Three weeks forward',
  'pj.week.prev': 'Previous week',
  'pj.week.next': 'Next week',
  'pj.month.prev': 'Previous month',
  'pj.month.next': 'Next month',
  'pj.month.entries': 'Hours registered in {month}',
  'pj.month.dayHours': '{hours} logged',
  'pj.view.day': 'Day',
  'pj.view.week': 'Week',
  'pj.day.empty': 'No hours registered on this day.',
  'pj.table.projectActivity': 'Project / activity',
  'pj.table.sum': 'Total',
  'pj.table.hours': 'Hours',
  'pj.row.new': 'New row',
  'pj.row.add': 'Add',
  'pj.row.remove': 'Remove the row',
  'pj.row.pickBoth': 'Pick a project and an activity',
  'pj.select.project': 'Pick a project …',
  'pj.select.activity': 'Pick an activity …',
  'pj.select.projectSearch': 'Search for a project …',
  'pj.select.activitySearch': 'Search for an activity …',
  'pj.select.projectEmpty': 'No projects match the search.',
  'pj.select.activityEmpty': 'No activities match the search.',
  'pj.project.createAction': 'Create a new project',
  'pj.activity.createAction': 'Create a new activity',
  'pj.activity.none': 'This project has no activities yet. Create one here.',
  'pj.lock.state.done': 'The timesheet is marked as finished through {date}.',
  'pj.lock.state.open': 'The timesheet is not marked as finished',
  'pj.lock.markWeek': 'Mark as finished through week {week}',
  'pj.lock.undo': 'Undo',
  'pj.lock.done': 'The timesheet is marked as finished through week {week}',
  'pj.lock.undone': 'The timesheet is open again',
  'pj.entry.newTitle': 'New time entry',
  'pj.entry.editTitle': 'Edit time entry',
  'pj.entry.invoicedLocked': 'These hours are invoiced and cannot be changed. Delete or credit the invoice draft to release them.',
  'pj.entry.periodLocked': 'The timesheet for this period is marked as finished.',
  'pj.entry.invoicedShort': 'Invoiced',
  'pj.field.project': 'Project',
  'pj.field.activity': 'Activity',
  'pj.field.hours': 'Hours',
  'pj.field.date': 'Date',
  'pj.field.description': 'Description',
  'pj.field.descriptionHint': 'What did the hours go to? The text follows onto the invoice.',
  'pj.field.name': 'Name',
  'pj.field.number': 'Number',
  'pj.field.customer': 'Customer',
  'pj.field.contact': 'Contact person',
  'pj.field.optional': 'Optional',
  'pj.field.defaultActivity': 'Default activity',
  'pj.field.product': 'Product',
  'pj.field.rate': 'Hourly rate',
  'pj.field.start': 'Start',
  'pj.field.end': 'End',
  'pj.field.color': 'Colour',
  'pj.field.status': 'Status',
  'pj.overview.title': 'Time overview',
  'pj.overview.week': 'Week overview',
  'pj.overview.month': 'Month overview',
  'pj.overview.reports': 'Reports',
  'pj.overview.total': 'Total registered',
  'pj.overview.billable': '{hours} billable',
  'pj.overview.weekEntries': 'Hours registered in week {week}',
  'pj.overview.empty': 'No hours registered in the period',
  'pj.overview.emptyTitle': 'No hours',
  'pj.filter.all': 'All',
  'pj.filter.period': 'Period',
  'pj.filter.billing': 'Billing',
  'pj.filter.billable': 'Billable',
  'pj.filter.nonBillable': 'Not billable',
  'pj.filter.invoicedLabel': 'Invoiced',
  'pj.filter.invoiced': 'Invoiced',
  'pj.filter.open': 'Not invoiced',
  'pj.report.title': 'Hours registered {from} – {to}',
  'pj.report.emptyTitle': 'No entries',
  'pj.report.emptyText': 'No hours in the selected period and filter.',
  'pj.report.print': 'Print',
  'pj.report.pdf': 'Download as PDF',
  'pj.report.pdfTitle': 'Time report',
  'pj.report.pdfError': 'Could not download the report.',
  'pj.report.pdfUnavailable': 'Report PDF is not connected to the backend.',
  'pj.report.opening': 'Opening print ...',
  'pj.basis.title': 'Invoice basis',
  'pj.basis.projectName': 'Project name',
  'pj.basis.searchPlaceholder': 'Project, customer …',
  'pj.basis.summary': '{count} uninvoiced entries from {from} to {to}',
  'pj.basis.selected': 'Selected',
  'pj.basis.costs': 'Expenses to rebill',
  'pj.basis.costText': 'Expense',
  'pj.basis.costSource': 'Source',
  'pj.basis.costAmount': 'Amount',
  'pj.basis.costEmployee': 'Employee expense · {name}',
  'pj.basis.costPurchase': 'Posted purchase',
  'pj.basis.timesheet': 'Attach a timesheet',
  'pj.basis.create': 'Create invoice draft',
  'pj.basis.created': 'Invoice draft created for {project}',
  'pj.basis.pickOne': 'Pick at least one entry',
  'pj.basis.error': 'Could not create the invoice draft.',
  'pj.basis.emptyTitle': 'No uninvoiced hours',
  'pj.basis.emptyText': 'Everything is invoiced, or no billable hours have been registered on projects with a customer yet.',
  'pj.cost.tab': 'Expenses',
  'pj.cost.title': 'Project expenses',
  'pj.cost.party': 'Employee / supplier',
  'pj.cost.voucher': 'Voucher',
  'pj.cost.openVoucher': 'View voucher',
  'pj.cost.noVoucher': 'The voucher is not available',
  'pj.cost.noVoucherHelp': 'The cost has no file attached to it.',
  'pj.cost.noVoucherShort': 'No voucher',
  'pj.cost.pending': 'Awaiting approval',
  'pj.cost.invoiced': 'Invoiced',
  'pj.cost.notBillable': 'Not billable',
  'pj.cost.toInvoice': 'To invoice',
  'pj.cost.searchLabel': 'Search',
  'pj.cost.searchPlaceholder': 'Description, employee, supplier …',
  'pj.cost.openSum': '{amount} to invoice',
  'pj.cost.totalAll': 'Total for all matches',
  'pj.cost.emptyTitle': 'No expenses',
  'pj.cost.emptyText': 'No costs are linked to a project yet. Vouchers are linked to a project in the inbox, on the purchase, or when the employee submits the expense.',
  'pj.billing.always': 'Always',
  'pj.billing.ask': 'Ask',
  'pj.billing.never': 'Never',
  'pj.activity.newTitle': 'New activity',
  'pj.activity.editTitle': 'Edit activity',
  'pj.activity.namePlaceholder': 'E.g. Consulting',
  'pj.activity.noProduct': 'None',
  'pj.activity.productHint': 'The hours are invoiced as "{product}" and posted to account {account}.',
  'pj.activity.noProductHint': 'Without a product the hours are posted as services on account 3020 with the standard VAT rate.',
  'pj.activity.rateHint': 'Excl. VAT. If left empty, the product price is used.',
  'pj.activity.neverHint': 'The hours are kept out of the invoice basis. Use this for holidays and internal work.',
  'pj.project.newTitle': 'Create a new project',
  'pj.project.newShort': 'New project',
  'pj.project.editTitle': 'Edit project',
  'pj.project.numberHint': 'Suggested: {number}',
  'pj.project.customerHint': 'Without a customer the hours cannot be invoiced.',
  'pj.project.noCustomer': 'No customer (internal project)',
  'pj.project.closed': 'Closed',
  'pj.settings.title': 'Timesheet settings',
  'pj.settings.activities': 'Activities',
  'pj.settings.projects': 'Projects',
  'pj.settings.noActivitiesTitle': 'No activities yet',
  'pj.settings.noActivitiesText': 'The activity decides the hourly rate and which product the hours are invoiced as.',
  'pj.settings.noProjectsFirst': 'Create a project first.',
  'pj.settings.noProjectsTitle': 'No projects yet',
  'pj.settings.noProjectsText': 'Create a project to start tracking hours.',
  'pj.toast.entrySaved': 'The hours are registered',
  'pj.toast.entryUpdated': 'The time entry is updated',
  'pj.toast.entryDeleted': 'The time entry is deleted',
  'pj.toast.activitySaved': 'The activity is saved',
  'pj.toast.activityDeleted': 'The activity is deleted',
  'pj.toast.projectSaved': 'The project is saved',
  'pj.toast.projectDeleted': 'The project is deleted',
  'pj.error.saveEntry': 'Could not save the time entry.',
  'pj.error.deleteEntry': 'Could not delete the time entry.',
  'pj.error.saveRows': 'Could not update the rows.',
  'pj.error.lock': 'Could not update the lock.',
  'pj.error.saveActivity': 'Could not save the activity.',
  'pj.error.deleteActivity': 'Could not delete the activity.',
  'pj.error.saveProject': 'Could not save the project.',
  'pj.error.deleteProject': 'Could not delete the project.',
  'pj.validation.projectName': 'The project needs a name.',
  'pj.validation.endBeforeStart': 'The end date cannot be before the start date.',
  'pj.validation.activityName': 'The activity needs a name.',
  'pj.validation.activityProject': 'The activity must belong to a project.',
  'pj.validation.entryDate': 'The time entry needs a date.',
  'pj.validation.entryHours': 'The number of hours must be greater than 0.',
  'pj.validation.entryHoursMax': 'A single entry cannot exceed 24 hours.',
  'pj.validation.entryNotFound': 'The time entry was not found.',
  'pj.validation.entryInvoiced': 'The time entry is already invoiced and cannot be changed.',
  'pj.validation.periodLocked': 'The timesheet for this period is marked as finished.',
  'svc.projectNotFound': 'The project was not found.',
  'svc.projectNumberTaken': 'That project number is already in use.',
  'svc.projectHasHours': 'The project has registered hours. Mark it as closed instead of deleting it.',
  'svc.projectClosed': 'The project is closed and cannot take new hours.',
  'svc.projectNeedsCustomer': 'The project needs a customer before the hours can be invoiced.',
  'svc.activityNotFound': 'The activity was not found.',
  'svc.activityHasHours': 'The activity has registered hours and cannot be deleted.',
  'svc.timeEntryNotFound': 'The time entry was not found.',
  'svc.timeTrackingLocked': 'The timesheet for this period is marked as finished.',
  'svc.pickTimeEntries': 'Pick at least one uninvoiced time entry.',
  'svc.timesheetInvoiceDescription': 'Hours on {project} in the period {from} – {to}.',
});
